angular.module('common.directives').directive('recordingTimeline', function () {
  return {
    scope: {
      deviceId: '='
    },
    templateUrl: './templates/recording-timeline.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'RecordingTimelineController'
  }
})
